import { AxiosRequestConfig } from "axios";

export const getOrderConfig = (ApplicationId: string): AxiosRequestConfig => {
  return {
    method: "get",
    url: `/application/${ApplicationId}/data`,
  };
};
